import React, { Component } from 'react';
import "./Site.css";
import Alert from "react-s-alert";
import _ from 'lodash';
import moment from "moment";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Button,
    ListGroup,
    ListGroupItem,
    UncontrolledCollapse
} from "reactstrap";

export default class DashboardInfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            count: props.count,
            iconType: props.iconType,
            link: props.redirectLink
        }
    }
    render() {
        const {
            name,
            count,
            iconType,
            link
        } = this.state;
        const togglerName = `${name}Toggler`;
        const metricName = _.startCase(name);
        const lotsToDoHere = count > 10;

        return (
                <Card className="mb-2">
                    <CardHeader id={togglerName} className="softGrayBG">
                        <Row className="align-items-center">
                            <Col xs="9" className="text-center">
                                <FontAwesomeIcon icon={iconType} className="mr-2 mb-3 d-inline cbdBrightBlue" /><br />
                                <strong className="navyBlue fontSize150"><i>{metricName}</i></strong>
                            </Col>
                            <Col xs="3">
                                <div className="float-right fontSize350 cbdDarkBlue">
                                    <span className={lotsToDoHere ? "text-danger" : ""}>
                                        <strong>{count}</strong>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </CardHeader>
                </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/DashboardInfoCard.js